export const menuOptions = [
  { label: "searchDictionary", url: "/search" },
  { label: "contributionRankings", url: "/leaderboard" },
  {
    label: "donateButton",
    url: "https://donorbox.org/speak-hokkien-campaign",
  },
  {
    label: "homePage",
    url: "https://www.speakhokkien.org",
  },
];
